import React, { useEffect, useState } from 'react';
import Network from './Requests';
import Checkboxes from './Checkboxes';
import usersImg from '../images/users.png';
import client from '../images/client.png';
import guest from '../images/guest.png';
import { useDispatch, useSelector } from 'react-redux';
import { clearUsers } from '../store/reducers/saveGuids';
import { useTranslation } from 'react-i18next';

export default function CompanyUser(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const initialBreadcrumbState = [
    {
      name: t('companyUser.breadcrumb.company'),
      projectGuid: props.projectGuid,
      idCompany: null,
      id: null,
      idUser: null,
      type: null,
    },
    {
      name: props.companyName,
      projectGuid: props.projectGuid,
      idCompany: props.companyId,
      id: null,
      idUser: null,
      type: 4,
    },
  ];

  const [users, setUsers] = useState([]);
  const [breadcrumb, setBreadcrumb] = useState(initialBreadcrumbState);
  const [usersSearch, setUsersSearch] = useState('');
  const [parent, setParent] = useState({
    projectGuid: props.projectGuid,
    idCompany: props.companyId,
    id: null,
    idUser: null,
    type: 4,
  });

  const guidAdd = useSelector((state) => state?.guids?.usersAddProject?.add);
  const guidDelete = useSelector((state) => state?.guids?.usersAddProject?.delete);

  useEffect(() => {
    getItems(parent?.projectGuid, parent?.idCompany, parent?.id, parent?.idUser, parent?.type);
  }, [props.projectGuid, parent]);

  const getItems = async (projectGuid, idCompany, id, idUser, type) => {
    const data = await new Network().GetUserCatalog(projectGuid, idCompany, id, idUser, type);
    setUsers(data);
  };

  const search = (e) => {
    setUsersSearch(e.target.value);
  };

  const next = (projectGuid, idCompany, id, idUser, type, name) => {
    setParent({ projectGuid, idCompany, id, idUser, type });
    setBreadcrumb([
      ...breadcrumb,
      { name, projectGuid, idCompany, id, idUser, type },
    ]);
  };

  const back = () => {
    setBreadcrumb((breadcrumb) => breadcrumb.slice(0, -1));
    setParent({
      name: breadcrumb[breadcrumb.length - 2].name,
      projectGuid: breadcrumb[breadcrumb.length - 2].projectGuid,
      idCompany: breadcrumb[breadcrumb.length - 2].idCompany,
      id: breadcrumb[breadcrumb.length - 2].id,
      idUser: breadcrumb[breadcrumb.length - 2].idUser,
      type: breadcrumb[breadcrumb.length - 2].type,
    });
  };

  const setCheckbox = (arrAdd, arrDelete, value) => {
    const usersAdd = arrAdd.filter((obj) => obj.userGuid == value);
    const usersDelete = arrDelete.filter((obj) => obj.userGuid == value);
    if (usersAdd.length > 0) return true;
    if (usersDelete.length > 0) return false;
    return null;
  };

  let chats = [];
  const saveUsers = async () => {
    for (let chat = 0; chat < props.chats.length; chat++) {
      const element = props.chats[chat];
      chats.push(element.guid);
    }
    await new Network().HandleUserInChats(chats, guidAdd, guidDelete);
    dispatch(clearUsers());
    props.closePopup();
  };

  const searchedUsers = users.filter((user) =>
    user.name.toLowerCase().includes(usersSearch.toLowerCase())
  );

  return (
    <div className="share">
      <div className="share--item">
        <div className="infoList--title">{t('companyUser.title')}</div>
      </div>
      <div
        className="share-close"
        onClick={() => {
          setParent({
            projectGuid: props.projectGuid,
            idCompany: props.companyId,
            id: null,
            idUser: null,
            type: 4,
          });
          setBreadcrumb(initialBreadcrumbState);
          props.close();
        }}
      >
        X
      </div>
      <div
        className="users-detail--container user-add"
        style={{
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '800px',
          overflow: 'hidden',
          backgroundColor: 'white',
          borderRadius: '8px',
        }}>
        <div
          className="users-fixed-header"
          style={{
            flexShrink: 0,
            padding: '10px',
            background: '#fff',
            zIndex: 1,
            maxHeight: '100px',
          }}>
          <div className="users--filter">
            <input
              type="text"
              value={usersSearch}
              placeholder={t('companyUser.searchPlaceholder')}
              onKeyDown={(e) => e.stopPropagation()}
              onChange={(event) => search(event)}
            />
          </div>
          <div className="project-breadcrumbs">
            {breadcrumb.length > 0 && (
              <div className="breadcrumb-back" onClick={breadcrumb.length > 1 && back}></div>
            )}
            <div className="breadcrumb-title">
              {breadcrumb.length > 0 &&
                breadcrumb.slice(-2).map((breadcrumb, index) => (
                  <div key={index}>{breadcrumb.name}/</div>
                ))}
            </div>
          </div>
        </div>
        <div
          className="users-scrollable-list"
          style={{
            overflowY: 'auto',
            flexGrow: 1,
            padding: '10px 16px',
          }}>
          {searchedUsers?.length == 0 && (
            <div className="share--item">{t('companyUser.nothingFound')}</div>
          )}

        {users?.length > 0 &&
          props.chats?.length > 0 &&
          users
            .filter((user) => user.name.toLowerCase().includes(usersSearch.toLowerCase()))
            .map((c) => (
              <div className="users-container" key={`${c.type}-${c.id ?? c.referredUserGuid}`}>
                <div className="users-checkbox">
                  {c.type == 7 && (
                    <Checkboxes
                      checked={
                        setCheckbox(guidAdd, guidDelete, c.referredUserGuid) != null
                          ? setCheckbox(guidAdd, guidDelete, c.referredUserGuid)
                          : c.existInProject
                      }
                      userGuid={c.referredUserGuid}
                      chatGuid={props.chats}
                      companyId={c.idCompany}
                    />
                  )}
                </div>
                <div
                  className="users-detail--person"
                      onClick={() => {
                        if (c.type !== 5) {
                          next(props.projectGuid, c.idCompany, c.id, c.idUser, c.type, c.name);
                        }
                      }}>
                  <div>
                    {c.type == 1 && <img src={client} alt="client" />}
                    {c.type == 2 && <img src={guest} alt="guest" />}
                    {c.type == 3 && <img src={usersImg} alt="group" />}
                    {c.type == 4 && <img src={usersImg} alt="company" />}
                    {c.type == 6 && <img src={usersImg} alt="department" />}
                    {c.type == 8 && <img src={usersImg} alt="role" />}

                        {c.login == null ? (
                          <span>{c.name}</span>
                        ) : (
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span>{c.name}</span>
                            <span>{c.login}</span>
                          </div>
                        )}
                      </div>
                      {c.type == 5 && (
                        <Checkboxes
                          checked={
                            setCheckbox(guidAdd, guidDelete, c.referredUserGuid) != null
                              ? setCheckbox(guidAdd, guidDelete, c.referredUserGuid)
                              : c.existInProject
                          }
                          userGuid={c.referredUserGuid}
                          chatGuid={props.chats}
                          companyId={c.idCompany}
                        />
                      )}
                    </div>
                  </div>
            ))
            }
        </div>

        {(guidAdd.length > 0 || guidDelete.length > 0) && (
          <div
            className="share-save-container"
            style={{
              flexShrink: 0,
              background: '#fff',
              padding: '17px 16px 0px 16px',
              position: 'sticky',
              bottom: 0,
              zIndex: 10,
              textAlign: 'center',
            }}>
            <div className="share-save" onClick={saveUsers}>
              {t('common.save')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
